module.exports = __webpack_public_path__ + "img/percent-water-tool.693749d6.png";